"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSortableField = void 0;
var PaymentSortableField;
(function (PaymentSortableField) {
    PaymentSortableField["CONTRACT_NUMBER"] = "contractNumber";
    PaymentSortableField["INPUT_DATE"] = "inputDate";
    PaymentSortableField["DEBITING_CURRENCY"] = "debitingCurrency";
    PaymentSortableField["AMOUNT"] = "instructedAmount";
    PaymentSortableField["VALUE_DATE"] = "valueDate";
    PaymentSortableField["BENEFICIARY_NAME"] = "beneficiaryName";
    PaymentSortableField["REFERENCE"] = "reference";
    PaymentSortableField["STATUS"] = "paymentStatus";
    PaymentSortableField["FRIENDLY_BATCH_ID"] = "friendlyBatchId";
})(PaymentSortableField = exports.PaymentSortableField || (exports.PaymentSortableField = {}));
